export var LANES = ["Top", "Jungle", "Mid", "Bottom", "Support"];
export var SCALING = ["Early", "Mid", "Late"];
export var ChampionTierScale;
(function (ChampionTierScale) {
    ChampionTierScale["S"] = "S";
    ChampionTierScale["A"] = "A";
    ChampionTierScale["B"] = "B";
    ChampionTierScale["C"] = "C";
    ChampionTierScale["D"] = "D";
})(ChampionTierScale || (ChampionTierScale = {}));
export var ChampionGameStyles;
(function (ChampionGameStyles) {
    ChampionGameStyles["Engage"] = "Engage";
    ChampionGameStyles["Pick"] = "Pick";
    ChampionGameStyles["Picks"] = "Picks";
    ChampionGameStyles["Protect"] = "Protect";
    ChampionGameStyles["Siege"] = "Siege";
    ChampionGameStyles["Split"] = "Split";
    ChampionGameStyles["Blind"] = "Blind";
    ChampionGameStyles["Poke"] = "Poke";
    ChampionGameStyles["Poking"] = "Poking";
    ChampionGameStyles["Disengage"] = "Disengage";
})(ChampionGameStyles || (ChampionGameStyles = {}));
